const getClosingMessage = ({ time, lang }) =>
    lang === 'es' ? `Cierra a las ${time}` : `Itxi ${time}etan`

export default getClosingMessage;